import SubNavigationMobile from "@/components/elements/SubNavigationMobile";
import UserContentTypes from "@/components/settings/UserContentTypes";
import UserPreferences from "@/components/settings/UserPreferences";
import useAuth from "@/hooks/auth";
import { useIsMobile } from "@/hooks/useIsMobile";
import AccountLayout from "@/layouts/AccountLayout";
import { useRouter } from "next/router";

export default function Preferences() {
  const { user } = useAuth({ middleware: "auth" });
  const router = useRouter();
  const { redirect_to } = router.query;
  const isMobile = useIsMobile();
  return (
    <AccountLayout title={"Preferences | Lucidity Insights"}>
      <div className='container'>
        {isMobile && <SubNavigationMobile label='Content Preferences' />}
        <p className='text-2xl font-semibold'>Preferences</p>
        <p className='pb-5 mt-1.5 text-sm border-b text-white/40'>
          Manage your Lucidity Insights content that curated only for you.
        </p>
        <div className='divide-y divide-white/10'>
          <div className='py-6'>
            <UserPreferences />
          </div>
          <div className='py-6'>
            <UserContentTypes />
          </div>
        </div>
      </div>
    </AccountLayout>
  );
}
